import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { SystemConfigurationResponseDTO } from '../DTOs/response/system-configuration-response-dto';
import { BeamConfigurationRequestDTO } from '../DTOs/request/beam-configuration-request-dto';
import { ResponseDTO } from '../DTOs/response/response-dto';
import { BeamResponseDTO } from '../DTOs/response/beam-response-dto';
import { CoverageLevelConfigurationRequestDTO } from '../DTOs/request/coverage-level-configuration-request-dto';
import { CoverageLevelResponseDTO } from '../DTOs/response/covergae-level-response-dto';
import { ServiceDurationConfigurationRequestDTO } from '../DTOs/request/service-duration-configuration-request-dto';
import { ServiceDurationResponseDTO } from '../DTOs/response/service-duration-response-dto';
import { ReceiverManufacturersConfigurationRequestDTO } from '../DTOs/request/receiver-manufacturers-configuration-request-dto';
import { RxManufacturerResponseDTO } from '../DTOs/response/receiver-manufacturer-response-dto';
import { PartnersConfigurationRequestDTO } from '../DTOs/request/partners-configuration-request-dto';

@Injectable({
    providedIn: 'root'
})
export class SystemConfigurationService {
    public constructor(private _http:HttpClient) { }

    public getSystemConfigInfo(): Observable<SystemConfigurationResponseDTO> {
        const url = environment.baseUrl + 'Configuration/system';
        return this._http.get<SystemConfigurationResponseDTO>(url);
    }

    public addNewBeam(newBeam: BeamConfigurationRequestDTO): Observable<BeamResponseDTO> {
        const url = environment.baseUrl + 'Configuration/beam';
        return this._http.post<BeamResponseDTO>(url, newBeam);
    }

    public updateBeams(updatedBeam: BeamConfigurationRequestDTO): Observable<BeamResponseDTO> {
        const url = environment.baseUrl + 'Configuration/beam';
        return this._http.put<BeamResponseDTO>(url, updatedBeam);
    }

    public deleteBeam(beamId: number | string): Observable<ResponseDTO> {
        const url = environment.baseUrl + 'Configuration/beam/' + beamId;
        return this._http.delete<ResponseDTO>(url);
    }

    public addNewCoverage(newCoverageData: CoverageLevelConfigurationRequestDTO): Observable<CoverageLevelResponseDTO> {
        const url = environment.baseUrl + 'Configuration/coveragelevel';
        return this._http.post<CoverageLevelResponseDTO>(url, newCoverageData);
    }

    public updateCoverage(updateCoverage: CoverageLevelConfigurationRequestDTO): Observable<CoverageLevelResponseDTO> {
        const url = environment.baseUrl + 'Configuration/coveragelevel';
        return this._http.put<CoverageLevelResponseDTO>(url, updateCoverage);
    }

    public deleteCoverage(coverageId: number | string): Observable<ResponseDTO> {
        const url = environment.baseUrl + 'Configuration/coveragelevel/' + coverageId;
        return this._http.delete<ResponseDTO>(url);
    }

    public addNewDuration(newDurationData: ServiceDurationConfigurationRequestDTO): Observable<ServiceDurationResponseDTO> {
        const url = environment.baseUrl + 'Configuration/serviceduration';
        return this._http.post<ServiceDurationResponseDTO>(url, newDurationData);
    }

    public updateDuration(updateCoverage: ServiceDurationConfigurationRequestDTO): Observable<ServiceDurationResponseDTO> {
        const url = environment.baseUrl + 'Configuration/serviceduration';
        return this._http.put<ServiceDurationResponseDTO>(url, updateCoverage);
    }

    public deleteDuration(durationId: number | string): Observable<ResponseDTO> {
        const url = environment.baseUrl + 'Configuration/serviceduration/' + durationId;
        return this._http.delete<ResponseDTO>(url);
    }

    public addNewRxManufacturer(newRxManfaData: ReceiverManufacturersConfigurationRequestDTO): Observable<RxManufacturerResponseDTO> {
        const url = environment.baseUrl + 'Configuration/manufacturer';
        return this._http.post<RxManufacturerResponseDTO>(url, newRxManfaData);
    }

    public updateRxManufacturer(updateRxManfa: ReceiverManufacturersConfigurationRequestDTO): Observable<RxManufacturerResponseDTO> {
        const url = environment.baseUrl + 'Configuration/manufacturer';
        return this._http.put<RxManufacturerResponseDTO>(url, updateRxManfa);
    }

    public deleteRxManufacturer(rxManfaId: number | string): Observable<ResponseDTO> {
        const url = environment.baseUrl + 'Configuration/manufacturer/' + rxManfaId;
        return this._http.delete<ResponseDTO>(url);
    }

    public addNewPartner(newPartner: PartnersConfigurationRequestDTO): Observable<ResponseDTO> {
        const url = environment.baseUrl + 'Configuration/partner';
        return this._http.post<ResponseDTO>(url, newPartner);
    }

    public updatePartner(updatePartner: PartnersConfigurationRequestDTO): Observable<ResponseDTO> {
        const url = environment.baseUrl + 'Configuration/partner';
        return this._http.put<ResponseDTO>(url, updatePartner);
    }

    public deletePartner(partnerId: number | string): Observable<ResponseDTO> {
        const url = environment.baseUrl + 'Configuration/partner/' + partnerId;
        return this._http.delete<ResponseDTO>(url);
    }

    public updateTestActivationLimit(testActivationLimit: number): Observable<ResponseDTO> {
        const obj = {
            testDuration: testActivationLimit
        };
        const url = environment.baseUrl + 'Configuration/testactivation/duration';
        return this._http.put<ResponseDTO>(url, obj);
    }

    public updateSupportActivationLimit(testActivationLimit: number): Observable<ResponseDTO> {
        const obj = {
            customerSupportActivationDuration: testActivationLimit
        };
        const url = environment.baseUrl + 'Configuration/contract/duration';
        return this._http.put<ResponseDTO>(url, obj);
    }
}
